import { useEffect, useState } from 'react';
import axios from '../api/axiosInstance';
import { useNavigate } from "react-router-dom";

function ProfileForm() {
    const [form, setForm] = useState({
        name: '',
        password: '',
        confirmPassword: '',
        birthday: '',
        gender: ''
    });
    const navigate = useNavigate();
    const [userAccount, setUserAccount] = useState("帳號");

    const [message, setMessage] = useState('');

    useEffect(() => {
        document.title = "基本資料維護";
        const token = localStorage.getItem('token');
        if (!token) return;

        axios.get('/api/User/me', {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            const data = res.data;
            setForm({
                name: data.name || '',
                password: '',
                birthday: data.birthday || '',
                gender: data.gender || ''
            });
            setUserAccount(data.account || "帳號");
        }).catch(() => {
            setMessage('無法讀取使用者資料');
        });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) return alert('請先登入');

        if (form.password && form.password !== form.confirmPassword) {
            alert("兩次輸入的密碼不一致！");
            return setMessage("兩次輸入的密碼不一致！");
        }

        try {
            await axios.put('/api/User/Profile', form, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const existingUser = JSON.parse(localStorage.getItem("user") || "{}");
            existingUser.name = form.name;
            localStorage.setItem("user", JSON.stringify(existingUser));

            setMessage('更新成功！');
            alert("更新成功！");
            navigate("/dashboard")
        } catch {
            setMessage('更新失敗，請稍後再試');
            alert("更新失敗，請稍後再試");
        }
    };

    return (
        <div className="container mt-4" style={{ maxWidth: '600px' }}>
            <h2 className="mb-3">基本資料維護</h2>

            {message && <div className="alert alert-info">{message}</div>}
            <div className="mb-3">
                <button className="btn btn-outline-secondary" onClick={() => navigate("/dashboard")}>
                    回到目錄
                </button>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">登入帳號：{userAccount}</label>
                </div>
                <div className="mb-3">
                    <label className="form-label">顯示姓名</label>
                    <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={form.name}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">登入密碼（若不更改可留空）</label>
                    <input
                        type="password"
                        name="password"
                        className="form-control"
                        value={form.password}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">再次輸入密碼</label>
                    <input
                        type="password"
                        name="confirmPassword"
                        className="form-control"
                        value={form.confirmPassword}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">生日</label>
                    <input
                        type="date"
                        name="birthday"
                        className="form-control"
                        value={form.birthday}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">性別</label>
                    <select
                        name="gender"
                        className="form-select"
                        value={form.gender}
                        onChange={handleChange}
                    >
                        <option value="">請選擇</option>
                        <option value="M">男</option>
                        <option value="F">女</option>
                    </select>
                </div>
                <div className="mb-3">
                    <button type="submit" className="btn btn-primary">儲存修改</button>
                </div>
            </form>
        </div>
    );
}

export default ProfileForm;
